import { apiOptions, apiRequest } from "../../utils";
import { API_HEADER, REQUISITON_SDERVICE_BASE_URL } from "../../constants";

const baseUrl = "";

export const templateFolders = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: `${REQUISITON_SDERVICE_BASE_URL}${baseUrl}/TemplateFolders`,
      method: "get",
      headers: API_HEADER,
      params,
      filters,
      sort,
      signal,
    });
    return apiRequest(options);
  },

  get: async (folderId) => {
    const options = await apiOptions({
      url: `${REQUISITON_SDERVICE_BASE_URL}${baseUrl}/TemplateFolders/${folderId}`,
      method: "get",
      headers: API_HEADER,
    });
    return apiRequest(options);
  },

  create: async (data, successMessage, failureMessage) => {
    const options = await apiOptions({
      url: `${REQUISITON_SDERVICE_BASE_URL}${baseUrl}/TemplateFolders`,
      headers: API_HEADER,
      method: "post",
      data: data,
    });
    const toastMessageConfig = {
      success: {
        message: successMessage,
      },
      failure: {
        message: failureMessage,
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  update: async (folderId, data, successMessage, failureMessage) => {
    const options = await apiOptions({
      url: `${REQUISITON_SDERVICE_BASE_URL}${baseUrl}/TemplateFolders/${folderId}`,
      headers: API_HEADER,
      method: "patch",
      data: data,
    });
    const toastMessageConfig = {
      success: {
        message: successMessage,
      },
      failure: {
        message: failureMessage,
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  delete: async (folderId, successMessage, failureMessage) => {
    const options = await apiOptions({
      url: `${REQUISITON_SDERVICE_BASE_URL}${baseUrl}/TemplateFolders/${folderId}`,
      headers: API_HEADER,
      method: "delete",
    });
    const toastMessageConfig = {
      success: {
        message: successMessage,
      },
      failure: {
        message: failureMessage,
      },
    };
    return apiRequest(options, toastMessageConfig);
  },
};
